"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
// Dependencies.
var events_1 = require("events");
var _ = require("lodash");
// Define required options.
var requiredOptions = [
    'MaxBatchSize',
    'MaxDelay',
    'MinDelay',
];
// Validate the specified options.
var validate = function (options) {
    // Loop through required options.
    requiredOptions.forEach(function (requiredOption) {
        // Was the required option specified?
        if (!options.hasOwnProperty(requiredOption)) {
            throw new Error("Missing required MessageBatcher option: " + requiredOption);
        }
    });
    // Validate batch size.
    if (isNaN(options.MaxBatchSize)) {
        throw new Error("MessageBatcher MaxBatchSize option must be a number");
    }
    if (!isFinite(options.MaxBatchSize)) {
        throw new Error("MessageBatcher MaxBatchSize option must be a finite number");
    }
    if (options.MaxBatchSize < 1) {
        throw new Error("MessageBatcher MaxBatchSize option cannot be less than 1");
    }
    // Validate maximum delay before a partial batch is released.
    if (isNaN(options.MaxDelay)) {
        throw new Error("MessageBatcher MaxDelay option must be a number");
    }
    if (!isFinite(options.MaxDelay)) {
        throw new Error("MessageBatcher MaxDelay option must be a finite number");
    }
    if (options.MaxDelay < 0) {
        throw new Error("MessageBatcher MaxDelay option cannot be less than 0");
    }
    // Validate minimum delay before a partial batch is released.
    if (isNaN(options.MinDelay)) {
        throw new Error("MessageBatcher MinDelay option must be a number");
    }
    if (!isFinite(options.MinDelay)) {
        throw new Error("MessageBatcher MinDelay option must be a finite number");
    }
    if (options.MinDelay < 0) {
        throw new Error("MessageBatcher MinDelay option cannot be less than 0");
    }
    if (options.MinDelay > options.MaxDelay) {
        throw new Error("MessageBatcher MinDelay option cannot be greater than MaxDelay");
    }
};
var MessageBatcher = /** @class */ (function (_super) {
    __extends(MessageBatcher, _super);
    // Instantiate.
    function MessageBatcher(options) {
        var _this = 
        // Call parent constructor.
        _super.call(this) || this;
        // Store queued messages.
        _this.fifo = [];
        // Flag to prevent waiting on first batch.
        _this.firstBatch = true;
        // Validate.
        validate(options);
        // Store options.
        _this.options = options;
        // Create debounced methods to release batches.
        _this.releaseBatchDebouncedMax = _.debounce(_this.releaseBatch.bind(_this), _this.options.MaxDelay, { 'maxWait': _this.options.MaxDelay });
        _this.releaseBatchDebouncedMin = _.debounce(_this.releaseBatch.bind(_this), _this.options.MinDelay, { 'maxWait': _this.options.MinDelay });
        // Method chaining.
        return _this;
    }
    // Fill the queue.
    MessageBatcher.prototype.Queue = function (messages) {
        var _this = this;
        // Convert single messages to an array.
        messages = [].concat(messages);
        // Loop through messages.
        messages.forEach(function (message) {
            // Add message to FIFO.
            _this.fifo.push(message);
            // Call a debounced method depending on queue length.
            _this.debounce(_this.fifo, _this.options.MaxBatchSize);
        }, this);
    };
    // Call one of the debounced methods depending on queue length.
    MessageBatcher.prototype.debounce = function (fifo, batchSize) {
        // Are there any messages left in the queue?
        if (fifo.length > 0) {
            // Does the FIFO contain a full batch?
            if (fifo.length >= batchSize) {
                // Is this the first batch?
                if (this.firstBatch) {
                    // Update flag.
                    this.firstBatch = false;
                    // Flush immediately.
                    this.releaseBatchDebouncedMax.flush();
                }
                else {
                    // Cancel long debounce method.
                    this.releaseBatchDebouncedMax.cancel();
                    // Call the short debounced method to enforce the minimum delay between batches.
                    this.releaseBatchDebouncedMin(fifo, batchSize);
                }
            }
            else {
                // Cancel short debounce method.
                this.releaseBatchDebouncedMin.cancel();
                // Call the long debounced method until we have a full batch, or max delay elapses.
                this.releaseBatchDebouncedMax(fifo, batchSize);
            }
        }
    };
    // Attempt to release a batch of messages.
    MessageBatcher.prototype.releaseBatch = function (fifo, batchSize) {
        // Get a batch.
        var batch = this.drainFIFO(fifo, batchSize);
        // Any messages?
        if (batch && batch.length) {
            // Release a batch.
            this.emit('batch', batch);
            // Continue draining the queue.
            this.debounce(fifo, batchSize);
        }
    };
    // Drain a batch from the queue.
    MessageBatcher.prototype.drainFIFO = function (fifo, batchSize) {
        // Is the queue empty?
        return fifo.length > 0 ? fifo.splice(0, batchSize) : fifo;
    };
    return MessageBatcher;
}(events_1.EventEmitter));
exports.MessageBatcher = MessageBatcher;
